var RootVariable = {
  CHECKBOX_CHECKED_BG: '--gui-checkbox-checked-bg',
  CHECKBOX_CHECKED_HOVER_BG: '--gui-checkbox-checked-hover-bg',
  CHECKBOX_CHECKED_DISABLED_BG: '--gui-checkbox-checked-disabled-bg',
  CHECKBOX_CHECKED_BORDER_COLOR: '--gui-checkbox-checked-border-color',
  CHECKBOX_CHECKED_HOVER_BORDER_COLOR: '--gui-checkbox-checked-hover-border-color',
  CHECKBOX_CHECKED_DISABLED_BORDER_COLOR: '--gui-checkbox-checked-disabled-border-color',
  CHECKBOX_BG: '--gui-checkbox-bg',
  CHECKBOX_HOVER_BG: '--gui-checkbox-hover-bg',
  CHECKBOX_DISABLED_BG: '--gui-checkbox-disabled-bg',
  CHECKBOX_BORDER_COLOR: '--gui-checkbox-border-color',
  CHECKBOX_HOVER_BORDER_COLOR: '--gui-checkbox-hover-border-color',
  CHECKBOX_DISABLED_BORDER_COLOR: '--gui-checkbox-disabled-border-color',
  CHECKBOX_BORDER_WIDTH: '--gui-checkbox-border-width',
  CHECKBOX_SIZE: '--gui-checkbox-size',
  CHECKBOX_RADIUS: '--gui-checkbox-radius',
  CHECKBOX_CHECKED_COLOR: '--gui-checkbox-checked-color',
  CHECKBOX_CHECKED_DISABLED_COLOR: '--gui-checkbox-checked-disabled-color',
  CHECKBOX_CHECKED_HOVER_COLOR: '--gui-checkbox-checked-hover-color',
  CHECKBOX_LABEL_FONT_SIZE: '--gui-checkbox-label-font-size',
  CHECKBOX_LABEL_FONT_WEIGHT: '--gui-checkbox-label-font-weight',
  CHECKBOX_LABEL_COLOR: '--gui-checkbox-label-color',
  CHECKBOX_LABEL_DISABLED_COLOR: '--gui-checkbox-label-disabled-color',
  CHECKBOX_LABEL_GAP: '--gui-checkbox-label-gap',
  CHECKBOX_LABEL_LINE_HEIGHT: '--gui-checkbox-label-line-height',
  CHECKBOX_ICON_TRANSFORM: '--gui-checkbox-icon-transform'
};

export { RootVariable };
//# sourceMappingURL=constant.js.map
